/**
 * Yarn Product Card - Carousel Slider & AJAX Quick Add
 */

(function () {
  'use strict';

  function initYarnProductSlider(root) {
    if (!root || root.dataset.ypcInit === 'true') return;
    root.dataset.ypcInit = 'true';

    var track = root.querySelector('[data-ypc-track]');
    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.ypc-card'));
    var prevBtn = root.querySelector('[data-ypc-prev]');
    var nextBtn = root.querySelector('[data-ypc-next]');
    var dotsContainer = root.querySelector('[data-ypc-dots]');

    if (!cards.length) return;

    var dots = [];

    function getCardStep() {
      if (cards.length < 2) return track.offsetWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function getMaxScrollIndex() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var step = getCardStep();
      if (maxScroll <= 4 || step <= 0) return 0;
      return Math.max(0, Math.round(maxScroll / step));
    }

    function renderDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      dots = [];

      var maxIndex = getMaxScrollIndex();
      var dotCount = maxIndex + 1;

      if (dotCount <= 1) {
        dotsContainer.style.display = 'none';
        if (prevBtn && prevBtn.parentElement) {
          prevBtn.parentElement.style.display = 'none';
        }
        return;
      }

      dotsContainer.style.display = 'flex';
      if (prevBtn && prevBtn.parentElement) {
        prevBtn.parentElement.style.display = 'flex';
      }

      for (var i = 0; i < dotCount; i++) {
        (function (idx) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ypc-dot' + (idx === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          dot.dataset.index = idx;
          dot.addEventListener('click', function () { scrollToIndex(idx); });
          dotsContainer.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function scrollToIndex(index) {
      if (!cards[index]) return;
      var step = getCardStep();
      var targetLeft = Math.min(index * step, track.scrollWidth - track.clientWidth);
      track.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });
    }

    function updateControls() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var step = getCardStep();
      var maxIndex = getMaxScrollIndex();

      var activeIdx = 0;
      if (maxScroll <= 4) {
        activeIdx = 0;
      } else if (scrollLeft >= maxScroll - 6) {
        activeIdx = maxIndex;
      } else if (step > 0) {
        activeIdx = Math.round(scrollLeft / step);
        activeIdx = Math.max(0, Math.min(activeIdx, maxIndex));
      }

      // Update dots
      if (dots.length) {
        dots.forEach(function (dot, idx) {
          if (idx === activeIdx) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }

      // Update arrow states
      if (prevBtn) {
        prevBtn.disabled = scrollLeft <= 4;
      }
      if (nextBtn) {
        nextBtn.disabled = scrollLeft >= maxScroll - 4;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var step = getCardStep();
        var targetLeft = Math.max(0, track.scrollLeft - step);
        track.scrollTo({ left: targetLeft, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var step = getCardStep();
        var maxScroll = track.scrollWidth - track.clientWidth;
        var targetLeft = Math.min(maxScroll, track.scrollLeft + step);
        track.scrollTo({ left: targetLeft, behavior: 'smooth' });
      });
    }

    // Passive scroll listener for syncing dots & arrows
    var scrollTimeout;
    track.addEventListener('scroll', function () {
      if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
      scrollTimeout = requestAnimationFrame(updateControls);
    }, { passive: true });

    // Drag-to-scroll support for mouse
    var isDown = false;
    var startX = 0;
    var scrollLeftVal = 0;

    track.addEventListener('mousedown', function (e) {
      if (e.target.closest('button, a, input')) return;
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeftVal = track.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeftVal - walk;
    });

    renderDots();
    updateControls();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        renderDots();
        updateControls();
      }, 150);
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ypc-quick-add]');
      if (!btn || btn.disabled || btn.classList.contains('ypc-btn--loading')) return;

      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var textSpan = btn.querySelector('.ypc-btn__text');
      var originalText = textSpan ? textSpan.textContent : 'Quick Add';

      btn.classList.add('ypc-btn--loading');
      if (textSpan) textSpan.textContent = 'Adding...';

      var addUrl = (window.theme && window.theme.routes_cart_add_url) ? window.theme.routes_cart_add_url + '.js' : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw err;
            });
          }
          return response.json();
        })
        .then(function (item) {
          btn.classList.remove('ypc-btn--loading');
          btn.classList.add('ypc-btn--success');
          if (textSpan) textSpan.textContent = 'Added ✓';

          if (typeof window.CartDrop === 'function') {
            window.CartDrop();
          } else {
            var cartUrl = (window.theme && window.theme.routes_cart_url) ? window.theme.routes_cart_url + '.js' : '/cart.js';
            fetch(cartUrl)
              .then(function (res) { return res.json(); })
              .then(function (cart) {
                var counts = document.querySelectorAll('.cartCountSelector, [data-cart-count]');
                counts.forEach(function (el) {
                  el.textContent = cart.item_count;
                });
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              })
              .catch(function (err) { console.error('Cart refresh error:', err); });
          }

          setTimeout(function () {
            btn.classList.remove('ypc-btn--success');
            if (textSpan) textSpan.textContent = originalText;
          }, 2000);
        })
        .catch(function (error) {
          console.error('Quick Add Error:', error);
          btn.classList.remove('ypc-btn--loading');
          if (textSpan) textSpan.textContent = (error && error.description) ? error.description : 'Error';

          setTimeout(function () {
            if (textSpan) textSpan.textContent = originalText;
          }, 2500);
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ypc-root]').forEach(initYarnProductSlider);
    initQuickAdd();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ypc-root]') || (e.target.matches('[data-ypc-root]') ? e.target : null);
    if (root) initYarnProductSlider(root);
  });

  document.addEventListener('yarn:product-cards:refresh', initAll);
})();
